import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { authSelector, errorSelector } from '../../selectors/loggedUser';
import { getConfigSelector } from '../../selectors/config';
import { changeConfigChildRoute, changeHomeTitleAndDescription } from '../../actions/config';
import { setUserLogin } from '../../actions/loggedUser';
import { signOut } from '../../../auth/actions/signout';

import EntryPoint from './EntryPoint';

const mapStateToProps = createStructuredSelector({
    loggedUser: authSelector,
    config: getConfigSelector,
    error: errorSelector
});

const mapDispatchToProps = { changeConfigChildRoute, setUserLogin, signOut, changeHomeTitleAndDescription };
export default connect(mapStateToProps, mapDispatchToProps)(EntryPoint);